
(function() {
  var result = { translations: { "en": { "i18n": { "duration": { "seconds": "{{ seconds }} sec", "minutes": "{{ minutes }} min", "hours": "{{ hours }} hr", "hoursAndMinutes": "{{ hours }} hr {{ minutes }} min", "days": "{{ days }} days", "shortForm": { "seconds": "{{ seconds }}s", "minutes": "{{ minutes }}m", "hours": "{{ hours }}h", "days": "{{ days }}d", "hoursAndMinutes": "{{ hours }}h {{ minutes }}m" } }, "dateTime": { "quarterAndYear": "Q{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, ext. {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "en": "static-7.1014"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.1014",
    "ar-eg": "static-7.1014",
    "bg": "static-7.1014",
    "bn": "static-7.1014",
    "ca-es": "static-7.1014",
    "cs": "static-7.1014",
    "da": "static-7.1014",
    "de": "static-7.1014",
    "el": "static-7.1014",
    "en-gb": "static-7.1014",
    "en": "static-7.1014",
    "es-mx": "static-7.1014",
    "es": "static-7.1014",
    "fi": "static-7.1014",
    "fr-ca": "static-7.1014",
    "fr": "static-7.1014",
    "he-il": "static-7.1014",
    "hr": "static-7.1014",
    "hu": "static-7.1014",
    "id": "static-7.1014",
    "it": "static-7.1014",
    "ja": "static-7.1014",
    "ko": "static-7.1014",
    "lt": "static-7.1014",
    "ms": "static-7.1014",
    "nl": "static-7.1014",
    "no": "static-7.1014",
    "pl": "static-7.1014",
    "pt-br": "static-7.1014",
    "pt-pt": "static-7.1014",
    "ro": "static-7.1014",
    "ru": "static-7.1014",
    "sk": "static-7.1014",
    "sl": "static-7.1014",
    "sv": "static-7.1014",
    "th": "static-7.1014",
    "tl": "static-7.1014",
    "tr": "static-7.1014",
    "uk": "static-7.1014",
    "vi": "static-7.1014",
    "x-pseudo": "static-7.1014",
    "zh-cn": "static-7.1014",
    "zh-hk": "static-7.1014",
    "zh-tw": "static-7.1014"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:en', {version: 'static-7.1014'}); }
})();


